/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
import {CustomTextField} from "../../../../../components/CustomTextField";
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import React from "react";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import {CleanIcon} from "../../../../../components/buttons/IconButtons";
import {MenuItem} from "@mui/material";

const ContractorCompanyFields = ({user, setUser, emptyFields, resetForm,getAllServiceType}) => {

    return (
        <>
            <div className={'row'}>
                { !user?.id && resetForm &&
                    <div className={'col-12 mb-2 d-flex justify-content-end'}>
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_ccf_clean_all_inputs'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={resetForm}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    </div>
                }

                <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                    <CustomTextField
                        id={'txt_ccf_acronym'}
                        length={128}
                        name={'acronym'}
                        value={user.acronym}
                        trans={'acronym'}
                        type={'text'}
                        onChange={(e) =>
                            setUser((prevData) => ({
                                ...prevData,
                                acronym: e.target.value,
                            }))
                        }
                        required={true}
                        emptyFields={emptyFields}
                    />
                </div>
                <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                    <CustomTextField
                        id={'txt_ccf_company_name'}
                        length={128}
                        name={'contractorCompanyName'}
                        value={user.contractorCompanyName}
                        trans={'company_name'}
                        type={'text'}
                        onChange={(e) => {
                            setUser((prevData) => ({
                                ...prevData,
                                contractorCompanyName: e.target.value,
                            }));
                        }}
                        required={true}
                        emptyFields={emptyFields}
                    />
                </div>
                <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                    <CustomTextField
                        id={'txt_ccf_address'}
                        length={128}
                        name={'address'}
                        value={user.address}
                        trans={'address'}
                        type={'text'}
                        onChange={(e) =>
                            setUser((prevData) => ({
                                ...prevData,
                                address: e.target.value,
                            }))
                        }
                        required={false}
                    />
                </div>
                <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                    <CustomSelectAndChildren
                        id="txt_ccf_service_type_id"
                        name="serviceTypeId"
                        emptyFields={emptyFields}
                        value={user.serviceTypeId}
                        onChange={(e) =>
                            setUser((prevData) => ({
                                ...prevData,
                                serviceTypeId: e.target.value,
                            }))
                        }
                        trans="service_type"
                        label="lbl_cur_serviceTypeId"
                        showNoSelectionOption={false}
                        required={true}
                    >
                        {getAllServiceType?.map((item) => {
                            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                        })}
                    </CustomSelectAndChildren>
                </div>

                <div className='col-sm-12'>
                    <CustomTextField
                        id={'txt_ccf_description'}
                        name={'description'}
                        value={user.description}
                        trans={'description'}
                        type={'text'}
                        disabled={false}
                        required={false}
                        onChange={(e) =>
                            setUser((prevData) => ({
                                ...prevData,
                                description: e.target.value,
                            }))
                        }
                        multiline={true}
                        rows={5}
                        maxRows={5}
                        length={512}
                    />
                </div>
            </div>
        </>
    );
};

export default ContractorCompanyFields;
